
import { defineComponent } from "vue";
import { IPreschoolTeacherAssignmentsModel } from "@/interfaces/modules";
import PreschoolTeacherAssignmentService from "@/api/Preschool/PreschoolTeacherAssignmentService";
import router from "@/router";

export default defineComponent({
  name: "SystemAcademicAssignmentsContent",
  data() {
    return {
      form: {
        dialog: false,
        record: {} as IPreschoolTeacherAssignmentsModel,
      },
      table: {
        filters: { search: "" },
        currentPage: 1,
        loading: false,
        headers: [
          { key: "TeacherName", label: "Docente", sortable: true },
          { key: "GroupName", label: "Grupo", sortable: true },
          { key: "AcademicYearName", label: "Año academico", sortable: true },
          { key: "CreatedByFormat", label: "Creación", sortable: true },
          { key: "ModifiedByFormat", label: "Última modificación", sortable: true },
          { key: "action", label: "Acciones", sortable: false },
        ],
        records: [] as IPreschoolTeacherAssignmentsModel[],
        rowsPerPage: 10,
      } as any,
    };
  },
  async mounted() {
    await this.load();
  },
  computed: {
    filteredItems(): IPreschoolTeacherAssignmentsModel[] {
      const search = this.table.filters.search.toLowerCase();
      return this.table.filters.search
        ? this.table.records.filter(
          (item) =>
            item.TeacherName?.toLowerCase().includes(search)
        )
        : this.table.records;
    },
    rows(): number {
      return this.table.records?.length || 0;
    },
  },
  methods: {
    async load() {
      this.table.loading = true;
      this.table.records = await PreschoolTeacherAssignmentService.GetAll();
      this.table.loading = false;
    },
    openForm(Id: any) {
      router.push(`academic-assignments-edit/${Id}`);
    }
  },
});
